import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

/**
 * ContentFooter:
 *  - Display the contents of all Sections Except for DesignSection
 *    in Web View
 */
export function ContentFooter(props) {
  const className = `${style.content_footer} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

ContentFooter.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * child components to render on ContentFooter
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

ContentFooter.defaultProps = {
  className: "",
};
